// Re-export from shared with useSearchQuery hook injected
import SharedSitesCombobox, {
  UnifiedSiteItem,
  SitesComboboxProps as SharedSitesComboboxProps,
} from "@hydrologiq/shared/components/inputs/SitesCombobox"
import { useSearchQuery } from "../../../hooks/useSearchQuery"

// Export the type for consumers
export type { UnifiedSiteItem }

// Omit useSearchQuery from props since we inject it
type SitesComboboxProps = Omit<SharedSitesComboboxProps, "useSearchQuery">

const SitesCombobox = (props: SitesComboboxProps) => {
  return <SharedSitesCombobox {...props} useSearchQuery={useSearchQuery as any} />
}

export default SitesCombobox
